import { rgba } from 'polished';
import { PalletteProps } from '../../../types/theme/pallette';
import styled from 'styled-components';

interface ItemProps extends PalletteProps {
  isSelected?: boolean;
}

export const ScheduleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: nowrap;
  justify-content: center;
  box-shadow: 0px 0px 50px rgba(200, 200, 200, 0.2);
  background-color: ${({ theme }: PalletteProps) => theme.white};
  border: 1px solid ${({ theme }: PalletteProps) => theme.gray8};
  border-radius: 10px;
  padding: 20px;
  margin: 4px 0 20px;
`;

export const SubTitle = styled.h2`
  color: ${({ theme }: PalletteProps) => theme.gray2};
  font-weight: 400;
  font-size: 1.125rem;
  margin-bottom: 18px;
`;

export const TabsContainer = styled.div`
  max-width: fit-content;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  background-color: ${({ theme }: PalletteProps) => theme.lightGray};
  border: 1px solid ${({ theme }: PalletteProps) => theme.gray7};
  border-radius: 10px;
  padding: 4px;
  gap: 5px;
  margin-bottom: 10px;
`;

export const TabItem = styled.button<ItemProps>`
  min-width: fit-content;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  align-items: center;
  justify-items: center;
  background: ${({ isSelected, theme, disabled }) => 
    disabled ? theme.lightGray : (isSelected ? theme.successColor : 'transparent')};
  border: ${({ isSelected, theme, disabled }) => 
    disabled ? `1px dashed ${(theme.gray4)}` : (isSelected ? theme.successColor : 'transparent')};
  padding: 8px 20px;
  font-size: 0.875rem;
  font-family: 'Inter', sans-serif;
  color: ${({ theme, isSelected, disabled }) => 
    disabled ? theme.gray4 : (isSelected ? theme.white : theme.gray2)};
  border-radius: 7px;
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out;
  position: relative;
  .faIcon {
    width: auto;
    height: 0.875rem;
    padding: 0 .5rem 0 0;
  }

  &:hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    background: ${({ isSelected, theme, disabled }) => 
      disabled ? theme.lightGray : (isSelected ? theme.successColor : rgba(theme.successColor, 0.15))};
    color:${({ isSelected, theme, disabled }) => 
      disabled ? theme.gray4 : (isSelected ? theme.white : theme.gray2)};
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: ${({ isSelected }) => (isSelected ? '0' : '100%')};
    width: 100%;
    height: 100%;
    background-color: ${({ theme, isSelected, disabled }) => 
      disabled ? 'transparent' : (isSelected ? theme.primaryColor : 'transparent')};
    border-radius: 7px;
    transition: left 0.3s ease-in-out;
    z-index: -1;
  }
`;
